<template>
  <b-modal id="admin_modal_form" lazy hide-footer centered size="lg">
    <template slot="modal-title">
      <i v-if="id_to_edit" class="far fa-pencil"></i>
      <i v-else class="far fa-plus fa-lg"></i>
      {{ id_to_edit ? 'Edition de la fiche' : 'Nouvelle fiche' }}
    </template>
    <component :is="config.form_component_name" :id_to_edit="id_to_edit"/>
  </b-modal>
</template>

<script>
// Tous les formulaires qui peuvent être chargés en modal

export default {
  name: "AdminModalForm",
  components: {
  },
  props: ["config", "id_to_edit"]
};
</script>


// WEBPACK FOOTER //
// src/components/Global/AdminModalForm.vue